import { Header as HeaderComponent } from './Header';
import { FeaturedContent as FeaturedContentComponent } from './FeaturedContent';
import { Gallery as GalleryComponent } from './Gallery';
import { Footer as FooterComponent } from './Footer';

export const Header = HeaderComponent;
export const FeaturedContent = FeaturedContentComponent;
export const Gallery = GalleryComponent;
export const Footer = FooterComponent;
